import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { createMemoryHistory, createBrowserHistory, History } from "history";

interface HistoryNavigationProps {
  onNavigate?: () => void;
  defaultHistory?: History;
  initialPathname?: string;
}

interface NavigationProps {
  pathname: string;
}

const mount = (
  el: Element,
  { onNavigate, defaultHistory, initialPathname }: HistoryNavigationProps,
) => {
  const history: History =
    defaultHistory ||
    createMemoryHistory({
      initialEntries: initialPathname ? [initialPathname] : [],
    });

  if (onNavigate)
    history.listen((obj) => {
      let { pathname, search, state } = obj;
      onNavigate(obj);
    });

  // reloading page to initial path on refresh
  if (initialPathname) {
    const { pathname, search } = history.location;
    if (pathname === initialPathname && search !== "")
      history.push({ pathname: initialPathname, search });
    if (pathname !== initialPathname) {
      history.push(initialPathname, search);
    }
  }

  const root = ReactDOM.createRoot(el as HTMLElement);
  root.render(
    <React.StrictMode>
      <App history={history} />
    </React.StrictMode>,
  );

  return {
    onParentNavigate({
      pathname: nextPathName,
      search: oldSearch,
      state,
    }: NavigationProps) {
      const { pathname } = history.location;
      if (pathname !== nextPathName)
        history.push({ pathname: nextPathName, search: oldSearch, state });
    },
  };
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// if (process.env.NODE_ENV === "development") {
const devRootEl = document.querySelector("#login-root");
if (devRootEl) mount(devRootEl, { defaultHistory: createBrowserHistory() });
// }

reportWebVitals();

export { mount };
